<section class="w-full flex flex-wrap justify-center items-center">
  <div class="w-full flex flex-wrap content-start bg-white dark:bg-gray-900 rounded-lg py-4 px-4">
    <img class="w-6" src="https://cloud.behkhaan.ir/assets/icons/beh-logo.svg">
    <div class="w-full flex flex-wrap justify-center mt-4 ">
      <img class="aspect-[0.70] h-[180px] rounded" [src]="data?.id | image : imageType.book : data.hasPhoto">
      <p class="w-full font-bold text-sm text-[#03121B] mt-4 text-center">{{data.name}}</p>
      @if (firstAuthor || firstTranslator) {
      <span class="font-medium text-xs text-gray-500 mt-2">
        {{ firstAuthor }}
        @if (firstAuthor && firstTranslator) {،}
        {{ firstTranslator }}
      </span>
      } @else {
      <span class="font-medium text-xs text-gray-500 mt-2">
        {{ data?.authors[0]?.name }}
      </span>
      }
      <p class="w-full font-medium text-xs text-gray-500 text-center">{{'نشر' + data?.publishers[0]?.title}}</p>

      <div class="w-full flex items-center justify-center mt-6">
        <span class="text-sm text-gray-500">
          {{ data?.averageRate || 0 | number : "0.1-1" }}
        </span>
        <span class="icon star-filled text-xl mr-1 text-system-rait border-l border-[#CED3D7] pl-3 ml-3"></span>
        <span class="font-medium text-xs text-gray-500">{{data.reviewCount}}</span>
        <span class="icon notepad-edit-regular text-xl text-gray-500 mr-1"></span>
      </div>

      <div class="w-full flex justify-between mt-6 text-center text-gray-500 text-xs">
        <div class="w-1/3 border-l border-[#CED3D7] px-2">
          <span class="block font-medium text-[10px] text-gray-400">خوانده‌اند</span>
          <span class="font-medium">{{ data.readCount }}</span>
        </div>
        <div class="w-1/3 border-l border-[#CED3D7] px-2">
          <span class="block font-medium text-[10px] text-gray-400">درحال خواندن</span>
          <span class="font-medium">{{ data.currentlyReadingCount }}</span>
        </div>
        <div class="w-1/3 px-2">
          <span class="block font-medium text-[10px] text-gray-400">خواهند خواند</span>
          <span class="font-medium">{{ data.wantToReadCount }}</span>
        </div>
      </div>


    </div>
  </div>

  <div class="flex flex-wrap flex-col justify-center items-center mt-4">
    <p class="text-xs text-gray-700 dark:text-gray-200 font-medium">بهخوان | شبکهٔ اجتماعی کتاب</p>

    <div class="relative w-full my-4">
      <div class="border-t border-gray-500 dark:border-gray-400 absolute top-1/2 left-0 right-0"></div>
      <p
        class="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-green-10 dark:bg-green-1000 px-2 text-green-500 text-sm font-medium">
        behkhaan.ir</p>
    </div>
  </div>
</section>